import { useMemo } from 'react';
import { RoleEnum } from '@juno/client-api/model';
import { Session } from '@juno/client-api/model';
import { useSettings } from '@juno/utils';

export const useSessionData = (roomInfo: any) => {
  const sessionData = useMemo(() => {
    if (roomInfo) {
      return roomInfo.session as Session;
    }
    return {} as Session;
  }, [roomInfo]);
  return sessionData;
};

export const useAmAdminModOrPresenter = (sessionData: Session) => {
  const { user } = useSettings();
  const userIsModeratorOrPresenter = useMemo(() => {
    if (user?.role === RoleEnum.NUMBER_1) return true;
    if (sessionData?.presenters?.find((presenter) => presenter.id === user?.id)) return true;
    if (sessionData?.moderators?.find((moderator) => moderator.id === user?.id)) return true;
    return false;
  }, [user, sessionData]);
  return userIsModeratorOrPresenter;
};
